
export const isEmptyResponseError = (error) =>
  error instanceof SyntaxError ||
  /Unexpected end of JSON|Failed to execute 'json'/i.test(error?.message || '');
